// 로딩 스피너 컴포넌트

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean; // 전체 화면을 차지할지 여부
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
};

export function LoadingSpinner({ message = '로딩 중...', size = 'md', fullScreen = false }: LoadingSpinnerProps) {
  const containerClass = fullScreen
    ? 'min-h-screen flex items-center justify-center bg-slate-100'
    : 'flex items-center justify-center';

  return (
    <div className={containerClass}>
      <div className="text-center">
        <div
          className={`mb-4 inline-block animate-spin rounded-full border-4 border-indigo-500 border-t-transparent ${sizeClasses[size]}`}></div>
        {message && <p className="text-slate-600">{message}</p>}
      </div>
    </div>
  );
}
